const COOKIE_NAME = 'cookie_consent';
const COOKIE_VALUE = 'accepted';
const COOKIE_DAYS = 1;

function initCookieBar() {
    const cookieBar = document.querySelector('.cookie-bar');
    const acceptButton = document.querySelector('.cookie-bar__button');

    let cookieConsent;
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(`${COOKIE_NAME}=`) === 0) {
            cookieConsent = cookie.substring(`${COOKIE_NAME}=`.length);
        }
    }

    if (cookieConsent === COOKIE_VALUE || !cookieBar || !acceptButton) {
        return;
    }

    if (cookieBar.classList.contains('hidden')) {
        cookieBar.classList.remove('hidden');
    }

    acceptButton.addEventListener('click', () => {
        const date = new Date();
        date.setTime(date.getTime() + (COOKIE_DAYS * 24 * 60 * 60 * 1000));
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${COOKIE_NAME}=${COOKIE_VALUE};${expires};path=/;SameSite=Lax;Secure`;

        if (!cookieBar.classList.contains('hidden')) {
            cookieBar.classList.add('hidden');
        }
    });
}

export default initCookieBar;
